module.exports = __webpack_public_path__ + "static/media/back-button.16ec0c1f.svg";